// extracted by mini-css-extract-plugin
module.exports = {"container":"Button_container__2UDoe","icon":"Button_icon__39lNG","hasText":"Button_hasText__2HcLt","stroked":"Button_stroked__3HKnp","dashed":"Button_dashed__3ZDFV"};